const SITE: {
  JAPAN: '/jp';
  MATCH: '/match';
  PORTUGUESE: '/pt';
  SPANISH: '/es';
  STIR: 'stir';
  OUR_TIME: 'ourtime';
} = {
  JAPAN: '/jp',
  MATCH: '/match',
  PORTUGUESE: '/pt',
  SPANISH: '/es',
  STIR: 'stir',
  OUR_TIME: 'ourtime',
};

export default SITE;
export type Site = typeof SITE[keyof typeof SITE];
